import {
  UploadSimple, Sparkle, MagnifyingGlass, FileXls, FunnelSimple,
} from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import Spinner from "@/components/Spinner";
import NewDebtorDialog from "@/components/debtor/NewDebtorDialog";
import ClearAllDialog from "@/components/debtor/ClearAllDialog";
import { useAuth } from "@/context/AuthContext";

export default function DebtorsToolbar({
  query,
  onQuery,
  tipoFilter,
  onTipoFilter,
  onUpload,
  importing,
  onSeed,
  onClearAll,
  onDownloadTemplate,
  onCreate,
  fileRef,
}) {
  const { user } = useAuth();
  const isRecobroAdmin = user?.email === "admin@recobro.ec";

  return (
    <div className="flex flex-col md:flex-row gap-3 md:items-center justify-between">
      <div className="flex flex-col sm:flex-row gap-2 sm:items-center flex-1">
        <div className="relative w-full sm:w-72">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            data-testid="search-debtors"
            placeholder="Buscar por nombre, email, teléfono…"
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            className="pl-9"
          />
        </div>
        <Select value={tipoFilter || "todos"} onValueChange={onTipoFilter}>
          <SelectTrigger className="w-full sm:w-56" data-testid="filter-tipo-registro">
            <FunnelSimple size={14} weight="bold" className="mr-1.5 text-muted-foreground" />
            <SelectValue placeholder="Filtrar por tipo" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="todos" data-testid="filter-tipo-todos">Todos los registros</SelectItem>
            <SelectItem value="cartera_vencida" data-testid="filter-tipo-cartera">Cartera vencida</SelectItem>
            <SelectItem value="venta_credito" data-testid="filter-tipo-venta">Venta a crédito</SelectItem>
            <SelectItem value="cuenta_por_pagar" data-testid="filter-tipo-pagar">Cuentas por pagar</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex gap-2 flex-wrap">
        <input
          ref={fileRef}
          type="file"
          accept=".xlsx"
          onChange={onUpload}
          className="hidden"
          id="excel-upload"
          data-testid="file-input"
        />
        <Button variant="outline" onClick={onDownloadTemplate} data-testid="download-template-btn">
          <FileXls size={16} weight="duotone" className="mr-2" /> Descargar plantilla
        </Button>
        <Button
          variant="outline"
          onClick={() => fileRef.current?.click()}
          disabled={importing}
          data-testid="upload-csv-btn"
        >
          {importing ? (
            <Spinner size="s" className="mr-2" />
          ) : (
            <UploadSimple size={16} weight="bold" className="mr-2" />
          )}
          {importing ? "Procesando Excel…" : "Importar Excel (.xlsx)"}
        </Button>
        <Button variant="outline" onClick={onSeed} data-testid="seed-demo-btn" className={isRecobroAdmin ? "" : "hidden"}>
          <Sparkle size={16} weight="duotone" className="mr-2" /> Demo
        </Button>

        <ClearAllDialog onClearAll={onClearAll} />

        <NewDebtorDialog onCreate={onCreate} />
      </div>
    </div>
  );
}
